import { getSecureAccountsApi } from "@Shared/utils/ajax";
export const getClientActivity = async (applicationId, pagination) => {
  const {
    offset = 0,
    limit = 20
  } = pagination;
  return getSecureAccountsApi({
    offset,
    limit,
    appId: applicationId
  }, "/client-activity");
};